import { useRef } from 'react';
import PropTypes from 'prop-types';

import './MobileBookingDropdown.css';
import RoomsAdultsSearch from 'components/roomsAdultsSearch/RoomsAdultsSearch';

const MobileBookingDropdown = ({ Lang = {} }) => {
    const bookingDropdownRef = useRef(null);

    return (
        <div className="ab-adults-container" ref={bookingDropdownRef}>
            <div
                id="ab-adults-dropdown"
                style={{
                    display: 'block',
                }}
            >
                <RoomsAdultsSearch Lang={Lang} isMobile={true} />
            </div>
        </div>
    );
};
MobileBookingDropdown.propTypes = {
    Lang: PropTypes.object,
};
export default MobileBookingDropdown;
